import React from "react";
import { Form } from "react-bootstrap";
import { capitalize } from "../../../../../../utils/helpers";

const PitchDeckTableRow = ({
  props,
  fieldName,
  unitName,
  displayName = fieldName,
  className,
  bottomText,
}) => {
  return (
    <>
      {unitName ? (
        <tr className="idea-checker-table-row">
          <th className="idea-checker-table-data-left companytitlecard">
            {capitalize(displayName)}
          </th>
          <td className="idea-checker-table-data-center">
            <Form.Control
              className="inputbox"
              type="number"
              min="1"
              name={fieldName}
              value={props.state[fieldName]}
              onChange={(e) => {
                props.setState({
                  type: "update value to state property",
                  stateName: fieldName,
                  value: parseFloat(e.target.value),
                });
              }}
            />
            <Form.Text className="text-muted" style={{ textAlign: "left" }}>
              {bottomText}
            </Form.Text>
          </td>
          <td className="idea-checker-table-data-right">
            <Form.Select
              required
              name={unitName}
              value={props.state[unitName]}
              onChange={(e) => {
                props.setState({
                  type: "update value to state property",
                  stateName: unitName,
                  value: e.target.value,
                });
              }}
            >
              <option>Unit</option>
              <option>K</option>
              <option>M</option>
              <option>B</option>
            </Form.Select>
            <Form.Text className="text-muted" style={{ textAlign: "left" }}>
              Select unit
            </Form.Text>
          </td>
        </tr>
      ) : (
        <tr className="idea-checker-table-row">
          <th className="idea-checker-table-data-left companytitlecard">
            {capitalize(displayName)}
          </th>
          <td colSpan={2} className="idea-checker-table-data-right">
            <Form.Control
              className="inputbox"
              type="number"
              min="1"
              name={fieldName}
              value={props.state[fieldName]}
              onChange={(e) => {
                props.setState({
                  type: "update value to state property",
                  stateName: fieldName,
                  value: parseFloat(e.target.value),
                });
              }}
            />
            <Form.Text className="text-muted" style={{ textAlign: "left" }}>
              {bottomText}
            </Form.Text>
          </td>
        </tr>
      )}
    </>
  );
};

export default PitchDeckTableRow;
